<mat-form-field class="no-hint w-100" floatLabel="always">
    <mat-label>Line Type</mat-label>
    <mat-select [(ngModel)]="dashArray" (ngModelChange)="onChange($event)" placeholder="Solid">
        <mat-select-trigger>
            <app-line-dash-array-view [dashArray]="dashArray"></app-line-dash-array-view>
        </mat-select-trigger>
        @for (dashArray of lineTypes; track $index) {
          <mat-option [value]="dashArray">
            <app-line-dash-array-view [dashArray]="dashArray"></app-line-dash-array-view>
          </mat-option>
        }
    </mat-select>
</mat-form-field>
